export default "__VITE_ASSET__b5d38c71__"